module.exports = __webpack_public_path__ + "static/media/facebook.1c2de647.png";